/**
 * Facts the guided authoring stages read from the corpus capture
 * (docs/inventory/extractor-grammar.md, W5.0 run of 2026-09-09, 216 extractors).
 * Copied here because a product package cannot import from docs/; when the
 * capture is re-run, refresh these lists from the generated tables. Every
 * value is CONFIRMED-by-corpus — what shipped extractors use, not what the
 * validator demands (the validator accepts any text: gate E5/E6).
 */

/** `integration` values by frequency; the long tail of one-offs is left to free text. */
export const INTEGRATIONS = [
  'Syslog', 'Syslog(CEF)', 'Syslog(KV)', 'NXLog', 'Syslog(LEEF)', 'AWS S3', 'RDBMS-Log-Shipper', 'Zscaler', 'Azure', 'Custom',
  'Syslog(XML)', 'Winlogbeat', 'Auditbeat', 'AWS', 'Office 365', 'G-Suite', 'Okta', 'CrowdStrike', 'Netskope', 'Mimecast',
] as const

/** `source-type` values, the UPPER-KEBAB majority (strays like `Security Device` stay free text). */
export const SOURCE_TYPES = [
  'ENDPOINT-SECURITY', 'FIREWALL', 'MANAGEMENT-SERVER', 'CLOUD', 'THREAT', 'APPLICATION', 'WAF', 'OS', 'ACCESS-GATEWAY', 'ZERO-TRUST',
  'NETWORK-OS', 'WEBSERVER', 'WEBFILTER', 'STORAGE', 'SWITCH', 'IPS', 'EMAIL-GATEWAY', 'NAC', 'OFFICE', 'DAM', 'DATABASE', 'PAM',
  'LOADBALANCER', 'MAILSERVER', 'CLOUD-SECURITY', 'CLOUD-STORAGE', 'PIM', 'PROXY', 'ROUTER', 'DHCP', 'NTA', 'DECOY', 'UTM',
  'NETWORK-SECURITY', 'DNS',
] as const

/** The commonest `kv-regex` (key-value decoder); `%KEY%` is the backend's placeholder. */
export const DEFAULT_KV_REGEX = '%KEY%=([^=]+)(?=\\s+\\w+=|$)'

/** The commonest key-value `decoder-regex`: two unnamed groups, key and value. */
export const DEFAULT_KV_DECODER_REGEX = '([^\\s\\|]+)=([^=]+)(?=\\s+\\w+=|$)'

/** Globals translate targets 211 and 208 of 216 extractors set — defaults for a new rule, not requirements. */
export const DEFAULT_GLOBAL_TARGETS = ['SystemTstamp', 'System'] as const

/** Streams a fallback commonly annotates besides OTHER (446 of 1003 rules fall back to a real stream). */
export const COMMON_FALLBACK_STREAMS = ['OTHER', 'THREAT', 'AUTHENTICATION', 'WINDOWS-EVENT', 'FIREWALL', 'CONFIGURATION', 'WEBFILTER'] as const
